






















export default {
  name: 'ImagePreviewDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '600'
    },
    image: {
      type: String,
      default: ''
    }
  },
  methods: {
    closeDialog(): void {
      this.$emit('close');
    }
  }
};
